import { SvgBase } from "../svg.base";

export const LiveFill = () => (
  <SvgBase
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path
      fill="#F02867"
      d="M1.875,7.3125 C1.875,5.5174531 3.3299531,4.0625 5.125,4.0625 L18.875,4.0625 C20.6700469,4.0625 22.125,5.5174531 22.125,7.3125 L22.125,16.6875 C22.125,18.4825469 20.6700469,19.9375 18.875,19.9375 L5.125,19.9375 C3.3299531,19.9375 1.875,18.4825469 1.875,16.6875 L1.875,7.3125 Z M9.77041848,14.7109254 C9.88791848,14.7784254 10.0187518,14.8125921 10.1504185,14.8125921 C10.2795852,14.8125921 10.4095852,14.7792587 10.5262518,14.7125921 L14.2270852,12.5559254 C14.4604185,12.4184254 14.6037518,12.1675921 14.6037518,11.8984254 C14.6037518,11.6275921 14.4604185,11.3767587 14.2279185,11.2392587 L10.5262518,9.08259208 C10.2920852,8.94842541 10.0037518,8.94925874 9.77041848,9.08509208 C9.53791848,9.22092541 9.39541848,9.47092541 9.39625182,9.74092541 L9.39625182,14.0542587 C9.39541848,14.3242587 9.53791848,14.5750921 9.77041848,14.7109254 Z"
    />
  </SvgBase>
);